import React from 'react'
import { stringToSEO } from '../../utils/stringOps'

const ShowPortfolios = ({ relatedContents }) => (
  <div className='article-portfolios'>

    {(relatedContents.length > 0) ? (
      <div className='related-portfolios-label'><strong>Related Portfolio(s): </strong></div>
    ) : null}

    <div className='related-portfolios-wrapper'>

      {(relatedContents.length > 0)
        ? relatedContents.map(item => (<div className='related-portfolio-item' key={item.id}>
          <a
            href={`/#/content/${item.id}/${stringToSEO(item.title)}?referrer=relatedportfolio_open`} rel='noopener noreferrer' target='_self'
          >{item.title}
          </a>
        </div>)) : null}
    </div>

  </div>
)

export default ShowPortfolios
